import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { reportError } from "../lib/reportError";
export const useTracks = initialTracks => {
  const [tracks, setTracks] = useState(initialTracks);
  useEffect(() => {
    const controller = new AbortController();
    api.get("/tracks", { signal: controller.signal }).then(({ data }) => {
      if (Array.isArray(data) && data.length) setTracks(data);
    }).catch(error => reportError("Track catalog unavailable; using sample catalog", error));
    return () => controller.abort();
  }, []);
  return tracks;
};